import React, { useState } from 'react';

import {
  Box,
  Typography
} from '@mui/material';

import ChangePasswordModal from './ChangePasswordModal';
import EditProviderModal from './EditProviderModal';
import PasswordSettingsCard from './PasswordSettingsCard';
import ProviderProfileCard from './ProviderProfileCard';

import {
  initialProviderProfile
} from './data';

import {
  pageTitleSx
} from './styles';

const PersonalProfile = () => {
  const [providerProfile, setProviderProfile] = useState(
    initialProviderProfile
  );

  const [openEditProvider, setOpenEditProvider] = useState(false);
  const [openPasswordModal, setOpenPasswordModal] = useState(false);

  const handleCloseEditProvider = () => {
    setOpenEditProvider(false);
  };

  const handleClosePasswordModal = () => {
    setOpenPasswordModal(false);
  };

  const handleSaveProvider = updatedProfile => {
    setProviderProfile(previousProfile => ({
      ...previousProfile,
      ...updatedProfile
    }));

    setOpenEditProvider(false);
  };

  const handleChangePassword = passwordData => {
    // TODO: Connect password update API.
    console.log('Change password', passwordData);
    setOpenPasswordModal(false);
  };

  return (
     <Box sx={{
          p: 1,
          width: '100%'
        }}>
      <Typography sx={pageTitleSx}>
        Personal Profile
      </Typography>

      <ProviderProfileCard
        data={providerProfile}
        onEdit={() => setOpenEditProvider(true)}
      />

      <PasswordSettingsCard
        onChangePassword={() => setOpenPasswordModal(true)}
        userName={providerProfile.userName}
      />

      <EditProviderModal
        data={providerProfile}
        onClose={handleCloseEditProvider}
        onSave={handleSaveProvider}
        open={openEditProvider}
      />

      <ChangePasswordModal
        onClose={handleClosePasswordModal}
        onSubmit={handleChangePassword}
        open={openPasswordModal}
      />
    </Box>
  );
};

export default PersonalProfile;